import { exists } from '@/api'

export interface BatchOnShelfReserveListCondition {
  dateFrom: string
  dateTo: string
  holdingBranchCode: string
  outputCondition: string
}

export function BatchOnShelfReserveListConditionFromJSON(
  json: any
): BatchOnShelfReserveListCondition {
  const _json = JSON.parse(json)

  return {
    dateFrom: exists(_json, 'date_from') ? _json.date_from : '',
    dateTo: exists(_json, 'date_to') ? _json.date_to : '',
    holdingBranchCode: exists(_json, 'holding_branch_code')
      ? _json.holding_branch_code
      : '',
    outputCondition: exists(_json, 'output_condition')
      ? _json.output_condition
      : '1'
  }
}
